import { getApps, initializeApp } from 'firebase/app';
import { getPerformance, trace } from 'firebase/performance';
import { getDefaultConfig } from './Store';

let firebaseApp = null;
let performanceInstance = null;

export const initializeFirebase = (config) => {
  if (firebaseApp && performanceInstance) {
    return;
  }

  try {
    // Check for existing Firebase app
    const existingApps = getApps();

    if (existingApps.length > 0) {
      firebaseApp = existingApps[0];
    } else {
      firebaseApp = initializeApp(config);
    }

    performanceInstance = getPerformance(firebaseApp);
  } catch (error) {
    console.error(`Error initializing Firebase: ${error}`);
  }
};

export const logTrace = (traceName) => {
  const { nodeEnv } = getDefaultConfig();

  if (!performanceInstance) {
    const errMsg = 'Firebase Performance Monitoring not initialized';

    if (!nodeEnv === 'development') {
      console.error(errMsg);
    } else {
      console.warn(errMsg);
    }

    return null;
  }

  return trace(performanceInstance, traceName);
};

export const logCustomAttribute = (traceInstance, name, value) => {
  if (!traceInstance) {
    console.error(`Firebase Performance: Trace instance is null`);

    return;
  }

  try {
    const sanitizedValue = sanitizeFirebaseAttribute(value);

    traceInstance.putAttribute(name, sanitizedValue);
  } catch (error) {
    console.error(`Firebase Performance: Error setting attribute "${name}":${value}`, error);
  }
};

// Adapted from https://docs.datadoghq.com/logs/guide/commonly-used-log-processing-rules/#email-address
// Checks for %40 in place of the "@" symbol, in case the email is URL-encoded (or %2540 if it's double encoded)
const emailRegex =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")(@|%40|%2540)(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;

export const sanitizeFirebaseAttribute = (value) => {
  // TODO: Check for other patterns in the future https://docs.datadoghq.com/logs/guide/commonly-used-log-processing-rules/
  const sanitized = value.replace(emailRegex, '[REDACTED_EMAIL]');

  if (sanitized !== value) {
    console.warn('Firebase Performance: Sanitized attribute value', { original: value, sanitized });
  }

  return sanitized;
};
